import React from 'react';
import { GraduationCap, Building2, Users, Percent, Calendar } from 'lucide-react';

interface Props {
  application: Record<string, any>;
}

export const TrainingProgressWidget: React.FC<Props> = ({ application: app }) => {
  const fundingPct = app.kfs_funding_percent ? Number(app.kfs_funding_percent) : 80;
  const totalCost = Number(app.kfs_training_cost || app.requested_amount || 0);
  const fundedAmount = totalCost * (fundingPct / 100);

  return (
    <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-lg shadow p-5 border border-cyan-200">
      <h3 className="font-bold text-sm flex items-center gap-2 mb-3 text-cyan-800">
        <GraduationCap size={16} />
        Szkolenie KFS
      </h3>
      <div className="space-y-3">
        {/* Funding bar */}
        {totalCost > 0 && (
          <div>
            <div className="flex justify-between text-xs text-gray-600 mb-1">
              <span className="flex items-center gap-1"><Percent size={12} /> Dofinansowanie KFS</span>
              <span>{fundingPct}%</span>
            </div>
            <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full" style={{ width: `${fundingPct}%` }} />
            </div>
            <div className="flex justify-between text-[10px] text-gray-500 mt-0.5">
              <span>KFS: {fundedAmount.toLocaleString('pl-PL')} zł</span>
              <span>Koszt: {totalCost.toLocaleString('pl-PL')} zł</span>
            </div>
          </div>
        )}
        <div className="grid grid-cols-2 gap-2 text-sm">
          {app.kfs_company_name && (
            <div className="flex items-center gap-2">
              <Building2 size={14} className="text-cyan-500 shrink-0" />
              <span className="truncate">{app.kfs_company_name}</span>
            </div>
          )}
          {app.kfs_training_provider && (
            <div className="flex items-center gap-2">
              <GraduationCap size={14} className="text-cyan-500 shrink-0" />
              <span className="truncate">{app.kfs_training_provider}</span>
            </div>
          )}
          {app.kfs_employee_count && (
            <div className="flex items-center gap-2">
              <Users size={14} className="text-cyan-500 shrink-0" />
              <span>{app.kfs_employee_count} uczestników</span>
            </div>
          )}
          {app.kfs_training_start && (
            <div className="flex items-center gap-2">
              <Calendar size={14} className="text-cyan-500 shrink-0" />
              <span>{new Date(app.kfs_training_start).toLocaleDateString('pl-PL')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
